import React, { useEffect, useState, useRef } from 'react';
import { Grid, Typography, Button, Box } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import {
  SimpleDialog,
  LoadingPage,
  FilterPod,
  ButtonLoading,
  TransactionReceiptDg,
  Icons,
  PriceLabel,
} from 'components';
import { enifyDateTime } from 'utility';
import { useNavigate } from 'react-router-dom';
import { useExportFile, useCopy } from 'hooks';
import { toFilterVOS } from 'components/FilterPod';
import SubsetServices from '../../services/Serivces';
import generateData from './generateData';
import InitFilters from '../constants/InitFiltering';
import useCustomHook from '../../hooks';
import { Menu, MenuItem, IconButton } from '@mui/material';
import { useParams } from 'react-router-dom';
import UploadDialog from './UploadDialog';
import TagingDialog from './TagingDialog';
import { ReportOfflineTransactionActions, ExportPodSpaceDg, TimelineDg } from 'components';
import ShareSerives from 'utility/ShareServices';
import FilterButton from 'components/FilterPod/FilterButton';
import { useCurrencyUnit } from 'hooks';

const Content = (props) => {
  const { userId, data } = props;
  const valueEnter = useParams();
  // -- STATES --//
  const currencyText = useCurrencyUnit(false);

  const {
    loading,
    setLoading,
    filterParams,
    setFilterParams,
    isOpenTagDialog,
    setIsOpenTagDialog,
    isOpenUploadDialog,
    setIsOpenUploadDialog,
    selectedRow,
    setSelectedRow,
    loadingPage,
    setLoadingPage,
    isLoadingExport,
    setIsLoadingEport,
    isShowExport,
    setIsShowEport,
    isOpenExportDG,
    setIsOpenExportDG,
    isOpenShowExportDG,
    setIsOpenShowExportDG,
    isOpenTransactionReceipt,
    setIsOpenTransactionReceipt,
    dataTimeLine,
    setDataTimeLine,
    timeLineLength,
    setTimeLineLength,
    statistics,
    setStatistics,
  } = useCustomHook();
  const [filters, setFilters] = useState(InitFilters(currencyText));

  const [openFilterDialog, setOpenFilterDialog] = useState(false);
  const handleCloseFilterDialog = () => setOpenFilterDialog(false);

  // -- HOOKS --//
  const classes = useStyle();
  const { copyItem } = useCopy();
  const tableRef = useRef();
  const [isOpenTimeLineDg, setIsOpenTimeLineDg] = useState(false);

  const [actionItems, setActionItems] = useState([
    {
      title: 'دریافت فایل خروجی با پسوند xls',
      type: 'xls',
      status: '',
    },
    {
      title: 'دریافت فایل خروجی با پسوند csv',
      type: 'csv',
      status: '',
    },
    {
      title: 'درخواست فایل خروجی با پسوند pdf',
      type: 'Pdf',
      status: 'offline',
    },
  ]);

  const navigate = useNavigate();
  const { downloadFile, isExporting } = useExportFile({
    //url: `/report/bill/${dataBusiness.userId}/accountBillForOther/export`,
    url: `/report/funder/${valueEnter?.id}/bills/export`,
    filename: `${(data?.firstName || 'bills') + ' ' + (data?.lastName || '')}`,
  });
  const getList = async (query) => {
    setStatistics({
      sumVariz: 0,
      sumBardasht: 0,
      amountChange: 0,
    });
    try {
      setLoading(true);
      const orderBy = [];
      const newFilters = [...filters];
      const filter = toFilterVOS([...newFilters]);
      let params = {
        offset: query?.page * query?.pageSize,
        size: query?.pageSize,
        startDate: enifyDateTime(filters[0]?.value?.start?.format('jYYYY/jMM/jDD 00:00:00')),
        endDate: enifyDateTime(filters[0]?.value?.end?.format('jYYYY/jMM/jDD 23:59:00')),
      };
      const data = {
        filterVOS: filter ?? [],
        parentParams: [],
        orderByElementVOS: orderBy ?? [],
      };

      setFilterParams({ data, params });

      const res = await SubsetServices.getFunderTransactions(
        {
          ...params,
          block: filters[1]?.value,
          description: filters[2]?.value,
          amountFrom: filters[3]?.value?.start,
          amountTo: filters[3]?.value?.end,
          documentId: filters[4]?.value,
        },
        valueEnter?.id,
      );
      let list = [];
      res?.data.result &&
        res?.data.result.map((a) => {
          a['thingUserId'] = valueEnter?.id;
        });
      //
      list = generateData(res?.data?.result, {
        page: query?.page,
        pageSize: query?.pageSize,
      });
      if (res?.data?.result?.length > 0) {
        let sumvariz = 0;
        let sumbradasht = 0;
        const listbradasht = Array.from(res?.data?.result).filter((a) => a.debtor == false);
        const listVariz = Array.from(res?.data?.result).filter((a) => a.debtor == true);
        listVariz.map((a) => {
          return (sumvariz += a?.amount);
        });
        listbradasht.map((a) => {
          return (sumbradasht += a?.amount);
        });
        setStatistics({
          sumVariz: sumvariz,
          sumBardasht: sumbradasht,
          amountChange: res?.data?.result[0].afterTxAmount,
        });
      }

      setLoading(false);
      reportOffileRequest();
      let d = {
        data: list,
        page: query?.page,
        totalCount: res?.data?.count,
      };
      return d; //passed to MaterialTable
    } catch (error) {
      setLoading(false);

      let d = {
        data: [],
        page: query?.page,
        totalCount: 0,
      };
      return d;
    }
  };
  const onExport = (data) => {
    if (data.type == 'Pdf') {
      onRequestExportPDF();
    } else {
      const d = {
        filterVOS: [],
        parentParams: [],
        orderByElementVOS: [],
      };
      downloadFile(data.type, d, filterParams?.params);
    }
  };
  const openUploadDialog = (row) => {
    setSelectedRow(row);
    setIsOpenUploadDialog(true);
  };
  const openTagDialog = (row) => {
    setSelectedRow(row);
    setIsOpenTagDialog(true);
  };
  const onFiltersChange = (newFilters) => {
    setFilters(newFilters);
    tableRef?.current?.onQueryChange?.({ page: 0 });
  };

  const onShowExportUrl = () => {
    setIsShowEport(true);
    SubsetServices.getAddressExportFile()
      .then((res) => {
        setIsShowEport(false);
        setIsOpenShowExportDG(false);
        setTimeout(() => {
          window.open(res?.result);
        }, 100);
      })
      .catch((error) => {
        setIsShowEport(false);
      });
  };
  const onRequestExportPDF = () => {
    setIsLoadingEport(true);
    const obj = {
      startDate: filterParams.params.startDate,
      endDate: filterParams.params.endDate,
    };
    if (filterParams.data.filterVOS.find((a) => a.key == 'block')) {
      obj['block'] = filterParams.data.filterVOS.find((a) => a.key == 'block').value;
    }
    if (filterParams.data.filterVOS.find((a) => a.key == 'documentId')) {
      obj['documentId'] = filterParams.data.filterVOS.find((a) => a.key == 'documentId').value;
    }
    if (filterParams.data.filterVOS.find((a) => a.key == 'description')) {
      obj['description'] = filterParams.data.filterVOS.find((a) => a.key == 'description').value;
    }
    if (filterParams.data.filterVOS.find((a) => a.id == '1578')) {
      obj['amountFrom'] = filterParams.data.filterVOS.find((a) => a.id == '1578').value;
    }
    if (filterParams.data.filterVOS.find((a) => a.id == '1579')) {
      obj['amountTo'] = filterParams.data.filterVOS.find((a) => a.id == '1579').value;
    }

    SubsetServices.reportPdf(obj, userId)
      .then((res) => {
        setIsLoadingEport(false);
        setIsOpenExportDG(true);
        reportOffileRequest();
      })
      .catch((error) => {
        setIsLoadingEport(false);
      });
  };
  /**
   * از قسمت عملیات گزینه رسید تراکنش کلیک میشود و این رویداد اتفاق میفتد
   */
  const onOpenRecieptTranaction = (rowData) => {
    setSelectedRow(rowData);
    setIsOpenTransactionReceipt(true);
  };

  /**
   * کلیک بر روی دکمه لیست درخواست گزارشات در کامپوونت ReportOfflineTransactionActions
   */
  const onclickListReports = () => {
    navigate('/ReportOfflineTransactions');
  };

  const reportOffileRequest = () => {
    const obj = {
      reportStatusKeys: ['TO_DO', 'DOING'],
      reportKeys: `FUNDER_TRANSACTIONS`,
    };
    ShareSerives.getRportOfflineRequest(obj)
      .then((res) => {
        setDataTimeLine(res?.result);
        setTimeLineLength(res?.count || 0);
      })
      .catch((error) => {});
  };
  useEffect(() => {
    !isOpenTimeLineDg && reportOffileRequest();
  }, [isOpenTimeLineDg]);
  return (
    <>
      {loadingPage ? (
        <LoadingPage />
      ) : (
        <Grid container>
          <Grid item xs={12}>
            <Box
              display="flex"
              justifyContent="end"
              alignItems="flex-end"
              style={{ marginBottom: 16 }}
            >
              <FilterButton setOpenFilterDialog={setOpenFilterDialog} filters={filters} />
              <ReportOfflineTransactionActions
                menuList={actionItems}
                onExport={onExport}
                loading={isExporting || isLoadingExport}
                onclickListReports={onclickListReports}
                setIsOpenTimeLineDg={setIsOpenTimeLineDg}
                timeLineLength={timeLineLength}
              />
            </Box>
            <Box>
              <FilterPod
                filters={filters}
                onChange={onFiltersChange}
                openFilterDialog={openFilterDialog}
                setOpenFilterDialog={setOpenFilterDialog}
                handleCloseFilterDialog={handleCloseFilterDialog}
              />
            </Box>
          </Grid>
          <Grid item xs={12}>
            <Grid>
              <Typography style={{ marginTop: '1em' }}>
                مجموع واریز:‌ <PriceLabel amount={statistics.sumVariz} currency={currencyText} />
              </Typography>
              <Typography style={{ marginTop: '1em' }}>
                مجموع برداشت: <PriceLabel amount={statistics.sumBardasht} currency={currencyText} />
              </Typography>
              <Typography style={{ marginTop: '1em' }}>
                مانده این صفحه:{' '}
                <PriceLabel amount={statistics.amountChange} currency={currencyText} />
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      )}
      <UploadDialog
        open={isOpenUploadDialog}
        setOpen={setIsOpenUploadDialog}
        row={selectedRow}
        tableRef={tableRef}
        userId={userId}
      />
      <TagingDialog
        open={isOpenTagDialog}
        setOpen={setIsOpenTagDialog}
        row={selectedRow}
        tableRef={tableRef}
        tags={[]}
      />

      <SimpleDialog fullWidth maxWidth="sm" open={isOpenShowExportDG} title="مشاهده فایل خروجی">
        <Grid container style={{ textAlign: 'justify' }}>
          برای مشاهده فایل، حداقل یک ساعت بعد از درخواست فایل خروجی به اکانت پاد اسپیس خود مراجعه
          فرمایید.
        </Grid>
        <Grid
          style={{ display: 'flex', flexDirection: 'row-reverse', marginTop: '16px', gap: '15px' }}
        >
          <ButtonLoading
            variant="contained"
            color="primary"
            onClick={onShowExportUrl}
            loading={isShowExport}
            disabled={isShowExport}
            name="پاد اسپیس"
          />

          <Button
            variant="contained"
            onClick={() => setIsOpenShowExportDG(false)}
            style={{ marginRight: '8px' }}
          >
            بستن
          </Button>
        </Grid>
      </SimpleDialog>
      <TransactionReceiptDg
        userId={userId}
        docId={selectedRow?.documentId}
        isOpenTransactionReceipt={isOpenTransactionReceipt}
        setIsOpenTransactionReceipt={setIsOpenTransactionReceipt}
      />
      <ExportPodSpaceDg isOpenExportDG={isOpenExportDG} setIsOpenExportDG={setIsOpenExportDG} />
      <TimelineDg
        isOpenTimetDG={isOpenTimeLineDg}
        setIsOpenTimetDG={setIsOpenTimeLineDg}
        reportKey="FUNDER_TRANSACTIONS"
      />
    </>
  );
};

const useStyle = makeStyles((theme) => ({
  copyIcon: {
    width: 20,
    height: 20,
    marginInlineEnd: theme.spacing(1),
    marginTop: -2,
  },
}));

const MoreDropDown = ({ otherMenus }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  return (
    <div>
      <IconButton
        aria-label="more"
        id="long-button"
        aria-controls={open ? 'long-menu' : undefined}
        aria-expanded={open ? 'true' : undefined}
        aria-haspopup="true"
        onClick={handleClick}
        size="large">
        <Icons icon="MoreHorizontal" color="#667585" size="20" />
      </IconButton>
      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        open={open}
        onClose={() => handleClose()}
      >
        {otherMenus.map((v, k) => (
          <MenuItem
            key={k}
            disabled={v?.disabled}
            onClick={() => {
              if (v?.disabled) return;
              v?.onClick?.();
              handleClose();
            }}
          >
            {v?.title}
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
};
export default Content;
